import {
  CATEGORIE_UNITAIRE,
  CATEGORIE_REGROUPEMENT,
  CATEGORIE_ECRAN_NUMERIQUE,
  CATEGORIE_REGROUPEMENT_NUMERIQUE,
  CATEGORIE_REGROUPEMENT_LC,
  CATEGORIE_SALON,
  CATEGORIE_SPONSORING,
  CATEGORIE_AUTRE,
  CATEGORIE_PRESSE,
  CATEGORIE_DIVERS,
  CATEGORIE_DISPOSITIF,
  CATEGORIE_LOCATION,
  CATEGORIE_IMPRESSION_AFFICHE, CATEGORIE_REGROUPEMENT_MAIRIE,
} from '@/configuration/catalogue/produitConf';

export default function getRouteOfPatrimonialProduct(typeProduit) {
  let routeName = null;
  switch (typeProduit) {
    case CATEGORIE_UNITAIRE:
      routeName = 'c.bodac.catalogue-face';
      break;
    case CATEGORIE_ECRAN_NUMERIQUE:
      routeName = 'c.bodac.catalogue-ecranNumerique';
      break;
    case CATEGORIE_REGROUPEMENT_NUMERIQUE:
      routeName = 'c.bodac.catalogue-reseauNumerique';
      break;
    case CATEGORIE_REGROUPEMENT:
      routeName = 'c.bodac.catalogue-reseau';
      break;
    case CATEGORIE_REGROUPEMENT_LC:
      routeName = 'c.bodac.catalogue-reseauLc';
      break;
    case CATEGORIE_REGROUPEMENT_MAIRIE:
      routeName = 'c.bodac.catalogue-reseauMairie';
      break;
    case CATEGORIE_SALON:
      routeName = 'c.bodac.catalogue-detailSalon';
      break;
    case CATEGORIE_SPONSORING:
      routeName = 'c.bodac.catalogue-detailSponsoring';
      break;
    case CATEGORIE_AUTRE:
      routeName = 'c.bodac.catalogue-detailAutre';
      break;
    case CATEGORIE_PRESSE:
      routeName = 'c.bodac.catalogue-detailPresse';
      break;
    case CATEGORIE_DIVERS:
      routeName = 'c.bodac.catalogue-divers';
      break;
    case CATEGORIE_DISPOSITIF:
      routeName = 'c.bodac.catalogue-dispositif';
      break;
    case CATEGORIE_LOCATION:
      routeName = 'c.bodac.catalogue-location';
      break;
    case CATEGORIE_IMPRESSION_AFFICHE:
      routeName = 'c.bodac.catalogue-impressionAffiche';
      break;
    default:
      routeName = null;
      break;
  }
  return routeName;
}
